import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=240ea32a&"
import script from "./Providers.vue?vue&type=script&lang=ts&"
export * from "./Providers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports